<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span
        >opportunity record with id: {{ $route.params.ID }} {{ $t("NotFound") }}.
      </span>
      <span>
        <span>{{ $t("Check") }} </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All opportunitys</router-link
        >
      </span>
    </vs-alert>

    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('MainInfo')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <MainData class="mt-4" :opportunity="Opportunity" />
            </div>
          </vs-tab>

          <vs-tab
            :label="$t('OpportunityFees')"
            icon-pack="feather"
            icon="icon-info"
          >
            <div class="tab-text">
              <OpportunityFees class="mt-4" :opportunity="Opportunity" />
            </div>
          </vs-tab>


          <vs-tab
            :label="$t('OpportunityDocuments')"
            icon-pack="feather"
            icon="icon-share-2"
          >
            <div class="tab-text">
              <OpportunityDocuments class="mt-4" :opportunity="Opportunity" />
            </div>
          </vs-tab>


        </vs-tabs>
      </div>
    </vx-card>



    <!-- <div class="vx-row mb-4 ml-10">
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          @click="cancel"
          class="px-4 w-full md:w-auto mr-6"
        >
          {{ $t("Back") }}</vs-button
        >
        <vs-button          
          :disabled="!isFormValid"
          @click="submitData"
          >{{ $t("SaveChange") }}</vs-button
        >
      </div>
    </div> -->

  </div>
</template>

<script>
import MainData from "./MainData.vue";
import OpportunityFees from "./OpportunityFees.vue";
import OpportunityDocuments from "./OpportunityDocuments.vue";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";

export default {
  components: {
    MainData,
    OpportunityFees,
    OpportunityDocuments,

  },
  data() {
    return {
      user_not_found: false,

    Opportunity: {}

    };
  },
  computed: {


  },
  methods: {
    initValues() {
      this.Opportunity = {};
    },
    submitData() {
      
      this.$validator.validateAll().then((result) => {
        if (result) {
          
          if (this.opportunity.ID !== null && this.opportunity.ID > 0) {
            this.$vs.loading();
            this.$store
              .dispatch("OpportunitiesList/updateItem", this.opportunity)
              .then(() => {
                this.$vs.loading.close();
                this.$store.dispatch("OpportunitiesList/fetchDataListItems");
                this.showSuccess();
                this.cancel();
                this.initValues();
              })
              .catch((err) => {
                
                this.$vs.notify({
                  time: 2500,
                  title: "Error",
                  text: err.response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
                console.error(err);
                this.$vs.loading.close();
              });
          } else {
            
            this.$store
              .dispatch("OpportunitiesList/addItem", this.opportunity)
              .then(() => {
                
                this.$store.dispatch("OpportunitiesList/fetchDataListItems");
                this.showSuccess();
                this.cancel();
                this.initValues();
              })
              .catch((err) => {
                

                this.$vs.notify({
                  time: 2500,
                  title: "Error",
                  text: err.response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
                console.error(err);
                this.$vs.loading.close();
              });
          }
        }
      });
    },

    showSuccess() {
      this.$vs.notify({
        time: 2500,
        title: "Success",
        text: "Saved Successfully",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
    },

    reset_data() {
      this.initValues();
    },
    cancel() {
      this.$router.go(-1);
    },
  },
  created() {
    
    if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
 
    const ID = this.$route.params.ID;

    
    if (ID != undefined && ID != 0) {
      
      this.$store
        .dispatch("OpportunitiesList/GetItemByID", ID)
        .then((res) => {
          
        // this.Opportunity = this.$store.state.OpportunitiesList.Opportunity;
         this.Opportunity = res.data.Data;
          //  const data = res.data.data;

          // this.Opportunity = {
          //   ID: data.id,
          //   OpportunityCode: data.opportunityCode,
          //   PropertyId: data.propertyId,
          //   OpportunityNameAr: data.opportunityNameAr,
          //   OpportunityNameEn: data.opportunityNameEn,
          //   OfferingValue: data.offeringValue,
          //   TotalTokens: data.totalTokens,
          //   TokenPrice: data.tokenPrice,
          //   CurrencyCode: data.currencyCode,
          //   MinPurchaseTokens: data.minPurchaseTokens,
          //   MaxPurchaseTokens: data.maxPurchaseTokens,
          //   SubscriptionStartAt: data.subscriptionStartAt,
          //   SubscriptionEndAt: data.subscriptionEndAt,
          //   OpportunityStatusId: data.opportunityStatusId
          // };
        })
        .catch((err) => {
          this.$vs.notify({
            title: this.$t("Error"),
            text: err.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          // }
          this.$vs.loading.close();
        });
    } else if (ID == undefined) {
      ID == 0;
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>


<style lang="scss">
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

vs-input {
  height: 37px;
}

datepicker {
  height: 37px;
}

.chk {
  height: 20px;
  width: 50px;
  margin-top: 30px;
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
